import { Socket } from 'socket.io-client';
import { CLIENT_SOCKET_EVENTS, SERVER_SOCKET_EVENTS } from './constants';

const sendChatMessage = (socket: Socket, username: string, message: string) => {
  socket.emit(SERVER_SOCKET_EVENTS.CHAT_MESSAGE, {
    username,
    message
  });
};

const loginWithFacebook = (
  socket: Socket,
  username: string,
  facebookToken: string
) => {
  socket.emit(SERVER_SOCKET_EVENTS.LOGIN, {
    username,
    facebookToken
  });
};

const loginWithGoogle = (
  socket: Socket,
  username: string,
  googleToken: string
) => {
  socket.emit(SERVER_SOCKET_EVENTS.LOGIN, {
    username,
    googleToken
  });
};

const onChatConnectionValid = (
  socket: Socket,
  callback: (payload: ConnectionValidPayload) => void
) => {
  socket.on(CLIENT_SOCKET_EVENTS.CONNECTED_VALID, callback);
};

const onChatMessageRecieved = (
  socket: Socket,
  callback: (message: ChatMessage) => void
) => {
  socket.on(CLIENT_SOCKET_EVENTS.CHAT_MESSAGE, callback);
};

export const clientMethods = {
  sendChatMessage,
  loginWithFacebook,
  loginWithGoogle,
  onChatMessageRecieved,
  onChatConnectionValid
};

export interface ChatUser {
  ip: string;
  id: string;
  username: string;
  facebookToken?: string;
  googleToken?: string;
}

export interface ChatMessage {
  id: string;
  sender: string;
  message: string;
  senderId: string;
  timestamp: number;
}

export interface ConnectionValidPayload {
  messages: ChatMessage[];
  userId: string;
}
